import { baseApi } from '@/features/api/baseApi';
import directus, { type DirectusErrorType } from '@/features/api/directus';
import type { IngestionsPage, IngestionsQueryArg } from '@/models/ingestion.type';
import { triggerFlow } from '@directus/sdk';

const INGESTIONS_FLOW_ID = 'feb5ac43-ddd0-4afe-b45c-9e777554e1dd';

const ingestionApi = baseApi
  .enhanceEndpoints({
    addTagTypes: ['ingestions'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getIngestions: builder.query<IngestionsPage, IngestionsQueryArg>({
        queryFn: async ({ page, pageSize, orderBy, filter }) => {
          try {
            const data = await directus.request<IngestionsPage>(
              triggerFlow('GET', INGESTIONS_FLOW_ID, {
                page: String(page),
                pageSize: String(pageSize),
                ...(orderBy ? { orderBy } : {}),
                // `filter` est une clé réservée du SDK : `queryToParams` ne la conserve que sous
                // forme d'objet (qu'il sérialise lui-même) et ignore une chaîne. Le typage de
                // `triggerFlow` (`Record<string, string>`) est trop restrictif, d'où le cast.
                ...(filter ? { filter: filter as unknown as string } : {}),
              }),
            );
            return { data };
          } catch (error: unknown) {
            return { error: error as DirectusErrorType };
          }
        },

        providesTags: ['ingestions'],
      }),
    }),
  });

export const { useGetIngestionsQuery } = ingestionApi;
